module.exports = __webpack_public_path__ + "img/ssss_default.ee55522e.png";